var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.617 22.13c-5.523 0-10-4.477-10-10 0-4.478 2.943-8.268 7-9.542v2.124a8.003 8.003 0 003 15.418 8.004 8.004 0 007.418-5h2.124c-1.274 4.057-5.064 7-9.542 7zm9.95-9h-10.95V2.18c.33-.033.663-.05 1-.05 5.523 0 10 4.477 10 10 0 .337-.017.671-.05 1zm-8.95-8.938v6.938h6.938a8.004 8.004 0 00-6.938-6.938z"
  })));
};
export default SvgAnalytics;